import { useMemo } from 'react';
import { EUserType, TUserDataUi } from 'data/types/user.types';
import { useAppSelector } from 'redux/store';

export const RFK_ADMIN_USER_TYPES: EUserType[] = [
  EUserType.READY_ADMIN,
  EUserType.SUPER_ADMIN,
];

export const isRfkAdminUser = (user: TUserDataUi): boolean =>
  !!user?.type?.some(type => RFK_ADMIN_USER_TYPES.includes(type));

export const useIsRfkAdmin = (): boolean => {
  const user = useAppSelector(state => state.userSlice.user);
  return useMemo(() => isRfkAdminUser(user), [user]);
};

export default useIsRfkAdmin;
